import styled from "styled-components";

export const Container = styled.div`


&{
  display:flex;
  flex-direction: column;
  justify-content: stretch;
  align-content: stretch;
  width: 100%;
  height: 100%;
  max-height: 100%;
  background: white;

  color: ${props => props.theme.colors.white};
  background-color:${props => props.theme.colors.white}; 
}

main{
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background-color: #EEE; */
  background: url(${process.env.PUBLIC_URL + "/assets/background.jfif"}) center center;
  background-repeat: no-repeat;
  background-size: cover;
}

p{
  margin: 12px 0px 12px 0px
}

.table-title{
  display: flex;
  padding-bottom: 1px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 1px;
  justify-content: space-between;
  color: ${p => p.theme.colors.white};
  background-color: ${props => props.theme.colors.secondary};
  height: ${props => props.theme.spacing.spacing_09};
  
  button{
    position: absolute;
    left: 5px;
    top: 10px;
    bottom: 10px;
    color: ${p => p.theme.colors.white};
    background-color: ${props => props.theme.colors.primary};
  }
}

#messages-area{
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
}

#input-area{
  height: ${props => props.theme.spacing.spacing_09};
  width: calc(100% - 10px);
  max-width: 1000px;
  display: flex;
  align-items: center;
  margin: 0px 5px 5px 5px;
  gap: 3px;
}

#attachFileLabel{
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.theme.spacing.spacing_09};
  height: ${props => props.theme.spacing.spacing_09};
  border-radius: 100%;
  border: none;
  outline: none;
  background-color: ${props => props.theme.colors.black};
  color: ${props => props.theme.colors.white};
  padding: 0px;

  :disabled{
    background-color: ${props => props.theme.colors.black};
  }
  :focus{
    background-color: ${props => props.theme.colors.primary};
  }
}
#attachFileLabel > * {
  width: 65%;
  height: 65%;
}

#attachFileInput{
  display: none;
}

#message-input{
  flex-grow: 1;
  height: 100%;
  padding-left: 10px;

  border-radius: 28px;
  border: none;
  outline: 0;

  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.black};
}
#message-input:disabled{
  background-color: ${props => props.theme.colors.black};
}

#send-message{
  width: ${props => props.theme.spacing.spacing_09};
  height: ${props => props.theme.spacing.spacing_09};
  border-radius: 100%;
  border: none;
  outline: none;
  background-color: ${props => props.theme.colors.black};
  color: ${props => props.theme.colors.white};
  padding: 10px;

  :disabled{
    background-color: ${props => props.theme.colors.black};
  }
  :focus{
    background-color: ${props => props.theme.colors.primary};
  }
}


ion-icon{
  color: ${props => props.theme.colors.white};
}
#send-message > *{
  width: 75%;
  height: 75%;
}
`